// Dark in-call theme for react-select, self-contained so the popover looks
// identical in every app that mounts it (education classroom, astrology
// consultation). Same styles-object idiom as @astro/astrologer-forms'
// selectStyles — that one is themed for light dashboard forms and can't be
// reused on a black control bar.
const cream = (a) => `rgba(247, 244, 239, ${a})`
const gold = (a) => `rgba(214, 164, 82, ${a})`

const deviceSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    backgroundColor: cream(0.06),
    borderColor: state.isFocused ? gold(0.55) : cream(0.15),
    borderRadius: 10,
    boxShadow: 'none',
    cursor: 'pointer',
    ':hover': { borderColor: gold(0.45) },
  }),
  valueContainer: (base) => ({ ...base, padding: '2px 10px' }),
  singleValue: (base) => ({ ...base, color: cream(0.92), fontSize: 12 }),
  placeholder: (base) => ({ ...base, color: cream(0.4), fontSize: 12 }),
  input: (base) => ({ ...base, color: cream(0.92), fontSize: 12, margin: 0 }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base, state) => ({
    ...base,
    padding: 6,
    color: state.isFocused ? gold(0.8) : cream(0.45),
    ':hover': { color: gold(0.8) },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#171310',
    border: `1px solid ${cream(0.14)}`,
    borderRadius: 10,
    overflow: 'hidden',
    zIndex: 60,
  }),
  menuList: (base) => ({ ...base, padding: 4, maxHeight: 180 }),
  option: (base, state) => ({
    ...base,
    fontSize: 12,
    borderRadius: 7,
    cursor: 'pointer',
    color: state.isSelected ? '#f2c877' : cream(0.85),
    backgroundColor: state.isSelected ? gold(0.18) : state.isFocused ? cream(0.08) : 'transparent',
    ':active': { backgroundColor: gold(0.22) },
  }),
  noOptionsMessage: (base) => ({ ...base, fontSize: 12, color: cream(0.45) }),
}

export default deviceSelectStyles
